// import React from 'react';
import styled from "styled-components";

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 30% 70%;
  padding-left: 5px;
  text-align: left;
`;

export default GridContainer;
